<template>
  <div class="scroll-to-explore-hint">
    <div class="arrow el-icon-arrow-up arrow-left-1" />
    <div class="arrow el-icon-arrow-up arrow-left-2" />
    <div class="copy">SCROLL TO EXPLORE</div>
    <div class="arrow el-icon-arrow-down arrow-right-1" />
    <div class="arrow el-icon-arrow-down arrow-right-2" />
  </div>
</template>

<script>
export default {
  name: 'ScrollToExploreHint',

  data: function () {
    return {
    }
  },

  mounted: function () {

  },

  beforeDestroy: function () {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import 'variables';



.arrow {
  position: absolute;
  top: 5px;
  transform: translate(0, -50%);
  font-size: 30px;
  font-weight: 400;
}

.arrow-left-1,
.arrow-left-2 {
  left: 0;
}

.arrow-right-1,
.arrow-right-2 {
  right: 0;
}

.arrow-left-2 {
  top: 15px;
}
.arrow-right-2 {
  top: 15px;
}
.scroll-to-explore-hint {
  pointer-events: none;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/atoms/ScrollToExploreHint.vue